import { render, staticRenderFns } from "./LayoutPublicWide.vue?vue&type=template&id=105f7932&scoped=true&lang=html&"
import script from "./LayoutPublicWide.vue?vue&type=script&lang=js&"
export * from "./LayoutPublicWide.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPublicWide.vue?vue&type=style&index=0&id=105f7932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f7932",
  null
  
)

export default component.exports